import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-13781284"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel } from '@vueuse/core';
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { addWxChat, updateUser } from '@/api/user';
export default {
  __name: 'index',
  props: {
    // 是否回显数据
    model: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Boolean,
      required: true
    },
    tenantId: {
      type: Number,
      required: true
    },
    clinicId: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;

    // 表单数据
    const formData = ref({
      username: '',
      // 姓名
      password: '',
      // 密码
      lastLoginClinic: '' // 排序
    });
    const resetForm = () => {
      formData.value = {
        username: '',
        // 姓名
        password: '',
        // 密码
        lastLoginClinic: props.clinicId // 排序
      };
    };
    watch(() => props.model, val => {
      if (val) {
        formData.value = {
          id: val.id,
          ...JSON.parse(JSON.stringify(val)),
          password: ''
        };
      } else {
        resetForm();
      }
    }, {
      deep: true,
      immediate: true
    });
    const emits = __emit;
    const isVisible = useVModel(props);
    const rules = ref({
      username: [{
        required: true,
        message: '不能为空',
        trigger: 'blur'
      }]
    });

    // 表单元素
    const formEl = ref(null);
    /**
     * 新增事件
     */
    const addNewsRoleHandler = async () => {
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          try {
            if (props.model) {
              await updateUser(formData.value);
            } else {
              await addWxChat(formData.value);
            }
            emits('refreshData');
            ElMessage({
              type: 'success',
              message: props.model ? '修改成功' : '添加成功'
            });
          } catch (error) {
            ElMessage({
              type: 'error',
              message: props.model ? '修改失败' : '添加失败'
            });
          } finally {
            isVisible.value = false;
          }
        } else {
          ElMessage({
            type: 'error',
            message: '验证失败'
          });
        }
      });
    };
    const closed = () => {
      formEl.value.resetFields();
      resetForm();
      if (props.model) {
        emits('clearModel');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '修改微信聊天用户' : '新增微信聊天用户',
        width: "50%",
        onClosed: closed,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: addNewsRoleHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          model: formData.value,
          rules: rules.value,
          style: {
            "max-width": "90%"
          },
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "姓名",
            prop: "username"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              disabled: !!__props.model,
              modelValue: formData.value.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.username = $event),
              placeholder: "请输入姓名"
            }, null, 8, ["disabled", "modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "密码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.password = $event),
              placeholder: "请输入密码"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "最后登录门诊id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              disabled: "",
              modelValue: formData.value.lastLoginClinic,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.lastLoginClinic = $event),
              placeholder: "请输入门诊id"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};